module.exports = __webpack_public_path__ + "img/borderImg.9b256c9d.png";